var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ContractEntityComponent',{attrs:{"partner":_vm.partner}}),_c('ContractPersonComponent',{attrs:{"showIban":false,"showContacts":false,"partner":_vm.partner,"parentSefa":_vm.parentSefa}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }